import React from 'react'
import PropTypes from 'prop-types'

import { Card, CardHeader, CardBody } from 'shards-react'
import withLoading from '../../../../hocs/withLoading/withLoading'

import InvalidTokenMessage from '../messages-component/InvalidTokenMessage'
import ApprovedSolicitationMessage from '../messages-component/ApprovedSolicitationMessage'
import DisapprovedSolicitationMessage from '../messages-component/DisapprovedSolicitationMessage'
import ConfirmSolicitationMessage from '../messages-component/ConfirmSolicitationMessage'
import ActiveMiniAppMessage from '../messages-component/ActiveMiniAppMessage'

import '../../invite-accept-screen.css'
import { useNavigate } from 'react-router-dom'

const InformationCard = props => {
    const { isValidToken, miniAppInformations, isApprovedSolicitation, isDisapprovedSolicitation } = props.informations

    const { acceptInvite } = props.actions
    const navigate = useNavigate()

    const goToLoginPage = () => navigate({ pathname: '/' })

    const showCardContent = () => {
        if (isValidToken) {
            const hasStatus = miniAppInformations && miniAppInformations.status
            const isAcceptedStatus = hasStatus && miniAppInformations.status === 'ACCEPTED'
            const isActiveStatus = hasStatus && miniAppInformations.status === 'ACTIVE'

            return isActiveStatus && isApprovedSolicitation ? (
                <ApprovedSolicitationMessage miniAppInformations={miniAppInformations} goToLoginPage={goToLoginPage} />
            ) : isActiveStatus && isDisapprovedSolicitation ? (
                <DisapprovedSolicitationMessage goToLoginPage={goToLoginPage} />
            ) : isActiveStatus && !isApprovedSolicitation && !isDisapprovedSolicitation ? (
                <ConfirmSolicitationMessage
                    miniAppInformations={miniAppInformations}
                    acceptInvite={acceptInvite}
                    goToLoginPage={goToLoginPage}
                />
            ) : isAcceptedStatus ? (
                <ActiveMiniAppMessage miniAppInformations={miniAppInformations} goToLoginPage={goToLoginPage} />
            ) : null
        } else {
            return <InvalidTokenMessage miniAppInformations={miniAppInformations} goToLoginPage={goToLoginPage} />
        }
    }

    InformationCard.propTypes = {
        isValidToken: PropTypes.bool,
        isFetching: PropTypes.bool,
        acceptInvite: PropTypes.func,
        isApprovedSolicitation: PropTypes.bool,
        isDisapprovedSolicitation: PropTypes.bool,
        informations: PropTypes.object,
        actions: PropTypes.object,
    }

    return (
        <Card className="invite-accept--card">
            <CardHeader className="invite-accept--title">Convite para colaborar</CardHeader>
            <hr />
            <CardBody className="invite-accept--body">
                <div className="invite-accept--card-container">{showCardContent()}</div>
            </CardBody>
        </Card>
    )
}

const WrappedComponent = withLoading(InformationCard)

export default WrappedComponent
